import { Box } from '@mui/material';
import React, { ReactNode, useState } from 'react';
import { useSelector } from 'react-redux';

import {
	getHistoryMode,
	getIsTicketHistoryLoading,
	getSidebarView,
	getTicketHistory,
} from 'store/ticket-service/selector';

import { HistoryChangesList } from 'components/ChangesVersioning/HistoryChangesList';
import { Header } from 'components/Header/MainHeader';
import { Sidebar } from 'components/Sidebar';

import * as Styled from './styled';

export const MainPageLayout = ({ children }: { children: ReactNode }) => {
	const isHistoryMode = useSelector(getHistoryMode);
	const ticketHistory = useSelector(getTicketHistory);
	const isHistoryLoading = useSelector(getIsTicketHistoryLoading);

	const [isShowDraft, setIsShowDraft] = useState(false);
	const [isCreating, setIsCreating] = useState(false);

	const sidebarView = useSelector(getSidebarView);

	return (
		<Styled.PageContainer className="rtl-able">
			<Header isCreating={isCreating} />

			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					width: '92%',
				}}
				className="rtl-able"
			>
				<Box
					sx={{
						display: 'flex',
						width: '100%',
						justifyContent: 'flex-start',
					}}
				>
					{window.innerWidth >= 900 || (window.innerWidth < 900 && sidebarView) ? (
						isHistoryMode ? (
							<HistoryChangesList
								ticketHistory={ticketHistory}
								isHistoryLoading={isHistoryLoading}
							/>
						) : (
							<Sidebar
								isShowDraft={isShowDraft}
								setIsShowDraft={setIsShowDraft}
								isCreating={isCreating}
								setIsCreating={setIsCreating}
							/>
						)
					) : null}

					<Box
						sx={{
							width: '100%',
							display: { xs: sidebarView ? 'none' : 'flex', md: 'flex' },
							overflowY: 'auto',
							overflowX: 'hidden',
							backgroundColor: '#EFEFEF',
							boxSizing: 'border-box',
						}}
					>
						<Box
							position="relative"
							display={'flex'}
							flexDirection={'column'}
							flexGrow={1}
							height="100%"
						>
							{children}
						</Box>
					</Box>
				</Box>
			</Box>
		</Styled.PageContainer>
	);
};
